export default "__VITE_ASSET__eBj3LV_O__"